import {Typography} from "@material-ui/core";
import GrayHeaderCard from "../../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {
    trafficType
} from "../../../../../../../../../../shared/components/dialogs/change-plan-by-sim-dialog/main/MainHelper";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import WifiIcon from "@material-ui/icons/Wifi";
import SmsOutlinedIcon from "@material-ui/icons/SmsOutlined";
import React from "react";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";
import {
    useMainOfferContentStyles
} from "../../../../../../../../../../shared/components/dialogs/change-plan-by-sim-dialog/main/main-offer-content/MainOfferContentStyles";
import {Skeleton} from "@material-ui/lab";
import {getRandomNumber} from "../../../../../../../../../../shared/utils/utils";

const DettaglioPlafondShare = (props) => {
    const classes = useMainOfferContentStyles()

    const currentPlafondShare = useSelector(state => state.contrattoDigitaleReducer.currentOffer.data)
    const loading = useSelector(state => state.contrattoDigitaleReducer.currentOffer.loading)

    const getTrafficIcon = (trafficIcon) => {
        if (trafficIcon === trafficType.VOCE) return (
            <PhoneOutlinedIcon style={{color: "#63cf38"}} fontSize={"small"}/>)
        if (trafficIcon === trafficType.DATI) return (<WifiIcon style={{color: "#63cf38"}} fontSize={"small"}/>)
        if (trafficIcon === trafficType.SMS) return (<SmsOutlinedIcon style={{color: "#63cf38"}} fontSize={"small"}/>)
    }

    return (
        <GrayHeaderCard title={
            <Typography variant="subtitle2">
                Dettaglio {props.selectedRow.nomePlafondShare}
            </Typography>
        }>
            {loading ?
                <Skeleton height={`${getRandomNumber(150, 320)}px`} animation='pulse' variant='rect'/> :
                <>
                    <Box marginY={2}>
                        <Typography variant={"overline"}>
                            {currentPlafondShare.trafficoCondivisioneListCaption}
                        </Typography>
                    </Box>
                    {currentPlafondShare.trafficoCondivisioneList?.length && currentPlafondShare.trafficoCondivisioneList.map((zoneItem, index) => {
                        return (
                            <Box key={`zoneItem-${index}`}
                                 marginBottom={2}
                                 className={classes.zoneBox}>
                                {getTrafficIcon(zoneItem.typeIcon)}
                                <Box component={"span"}
                                     marginLeft={2}>
                                    <Typography variant={"subtitle2"}>
                                        {zoneItem.typeDescription}
                                    </Typography>
                                </Box>
                            </Box>
                        );
                    })}
                </>
            }
        </GrayHeaderCard>
    )
}

export default DettaglioPlafondShare;